import { render } from "./SplashScreenComponent.vue?vue&type=template&id=97ce6a16&scoped=true"
const script = {}

import "./SplashScreenComponent.vue?vue&type=style&index=0&id=97ce6a16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ce6a16"]])

export default __exports__